import type { Page } from '../../types';
import { getColumns, getKeys, getRows } from '../../../components/form/CoreCphConsolidatedInput';

const costPerHireScs: Page[] = [
  {
    pageType: 'question',
    title: 'SCS Recruitment',
    name: 'cost-per-hire-scs-internal',
    description: `
      <strong>Overview</strong><br>
      Please complete the following sections regarding Cost Per Hire. When calculating your figures, distinguish between Internal Costs (e.g., the value of staff time spent sifting, interviewing, etc) and External Costs (e.g., third-party advertising, search firm fees, etc).<br><br>
      For each cost category, use the tick boxes to indicate the extent to which these expenses are captured in your data. Finally, provide the mean average internal and external cost per successful appointment made during this reporting period for both internal and external streams.
    `,
    questions: [
      {
        questionType: 'coreCostInteralInput',
        title: 'Internal Cost Inclusions',
        name: 'cph-scs-internal-inclusions',
        hideOptionalLabel: true,
        detailsHeading: 'More information',
        detailsContent:
          'Internal costs are likely to be: staffing time and resource planning, sifting, interview time (measured by representative sampling); departmental recruitment team budget (prorated to align with the specified reporting period); resource attributed to handling candidate enquiries.',
        rules: {
          required: false,
        },
      },
      {
        questionType: 'coreCostSCSInput',
        title: 'Average internal cost per hire for SCS',
        name: 'cph-scs-internal',
        detailsHeading: 'More information',
        detailsContent:
          'Failed campaigns in the reporting period: Where no appointable candidate was identified or all appointable candidates withdraw before starting in post',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments and observations',
        name: 'cph-scs-internal-comments',
        hint: 'Please outline any factors that may explain quarter-on-quarter change or influence these reported figures.',
        rules: {
          required: true,
        },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'SCS Recruitment',
    name: 'cost-per-hire-scs-external',
    description: `
      <strong>Overview</strong><br>
      Please complete the following sections regarding Cost Per Hire. When calculating your figures, distinguish between Internal Costs (e.g., the value of staff time spent sifting, interviewing, etc) and External Costs (e.g., third-party advertising, search firm fees, etc).<br><br>
      For each cost category, use the tick boxes to indicate the extent to which these expenses are captured in your data. Finally, provide the mean average internal and external cost per successful appointment made during this reporting period for both internal and external streams.
    `,
    questions: [
      {
        questionType: 'coreCostExternalInput',
        title: 'External Cost Inclusions',
        name: 'cph-scs-external-inclusions',
        hideOptionalLabel: true,
        detailsHeading: 'More information',
        detailsContent:
          'External costs are likely to be: advertising budget; Application Tracking System (ATS) contract; external search firm and outsourcing costs e.g. SCS assessments.',
        rules: {
          required: false,
        },
      },
      {
        questionType: 'coreCostSCSInput',
        title: 'Average external cost per hire for SCS',
        name: 'cph-scs-external',
        detailsHeading: 'More information',
        detailsContent:
          'Failed campaigns in the reporting period: Where no appointable candidate was identified or all appointable candidates withdraw before starting in post',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments and observations',
        name: 'cph-scs-external-comments',
        hint: 'Please outline any factors that may explain quarter-on-quarter change or influence these reported figures.',
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default costPerHireScs;
